import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { API_URL } from '../../config';
import { Link, useLocation } from 'react-router-dom';
import { PermissionWrapper, hasPermission } from '../../helpers/permission.js';

const CompanyHeader = () => {
    const [company, setCompany] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const token = localStorage.getItem("authToken");
    const location = useLocation();

    const fetchCompany = async () => {
        try {
            setLoading(true);
            const response = await axios.get(`${API_URL}settings/company/company-info`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            });
            setCompany(response.data.data); // Adjust this path if the API structure differs
        } catch (error) {
            setError(error.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchCompany();
    }, []);

    const isActive = (path) => location.pathname.toLowerCase() === path.toLowerCase() ? 'active' : '';

    return (
        <div className="profile-header">
            <div className="profile-header-cover"></div>
            <div className="profile-header-content">
                <div
                    className="profile-header-img"
                    style={{ verticalAlign: "middle" }}
                >
                    <img src={company.company_logo} alt="Company Logo" />
                </div>
                <div className="profile-header-info">
                    <h4 className="m-t-sm">{company.company_name}</h4>
                    <h5 className="m-t-sm">{company.company_address}</h5>
                </div>
            </div>
            <PermissionWrapper module="settings_company" action="edit">
                <ul
                    className="profile-header-tab pb-2 nav-tabs"
                    style={{
                        display: "flex",
                        flexWrap: "wrap",
                        alignItems: "center",
                        borderBottom: "1px solid #c8c7cc",
                        paddingLeft: "8.75rem",
                        whiteSpace: "normal",
                        rowGap: "4px",
                        paddingBottom: "6px",
                    }}
                >
                    {/* Conditionally show tabs if the user has edit permissions */}
                    {/* Replace with actual permission checks or hardcoded */}
                    <li className="nav-item">
                        <Link to="/Settings/Company" className={`nav-link ${isActive('/Settings/Company')}`} style={{ padding: "10px 10px", fontSize: "12px", whiteSpace: "nowrap" }}>
                            Home
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link to="/Settings/Company/edit" className={`nav-link ${isActive('/Settings/Company/edit')}`} style={{ padding: "10px 10px", fontSize: "12px", whiteSpace: "nowrap" }}>
                            Edit Company Info
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link
                            to="/Settings/Company/editConfigs"
                            className={`nav-link ${isActive('/Settings/Company/editConfigs')}`}
                            style={{ padding: "10px 10px", fontSize: "12px", whiteSpace: "nowrap" }}
                        >
                            Edit Configurations
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link
                            to="/Settings/Company/editPrintConfigs"
                            className={`nav-link ${isActive('/Settings/Company/editPrintConfigs')}`}
                            style={{ padding: "10px 10px", fontSize: "12px", whiteSpace: "nowrap" }}
                        >
                            Edit Print Details
                        </Link>
                    </li>
                    {/* <li className="nav-item">
                    <Link
                        to="/Settings/Company/editOffer"
                        className="nav-link active"
                    >
                        Edit Offer Details
                    </Link>
                </li> */}
                    <li className="nav-item">
                        <Link
                            to="/Settings/Company/editCallConfigs"
                            className={`nav-link ${isActive('/Settings/Company/editCallConfigs')}`}
                            style={{ padding: "10px 10px", fontSize: "12px", whiteSpace: "nowrap" }}
                        >
                            Edit Call Api Details
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link
                            to="/Settings/Company/editWhatsappConfigs"
                            className={`nav-link ${isActive('/Settings/Company/editWhatsappConfigs')}`}
                            style={{ padding: "10px 10px", fontSize: "12px", whiteSpace: "nowrap" }}
                        >
                            Edit Whatsapp Api Details
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link
                            to="/Settings/Company/testNotification"
                            className={`nav-link ${isActive('/Settings/Company/testNotification')}`}
                            style={{ padding: "10px 10px", fontSize: "12px", whiteSpace: "nowrap" }}
                        >
                            Test Notification
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link
                            to="/Settings/Company/carparvaLogin"
                            className={`nav-link ${isActive('/Settings/Company/carparvaLogin')}`}
                            style={{ padding: "10px 10px", fontSize: "12px", whiteSpace: "nowrap" }}
                        >
                            Carparva Login
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link
                            to="/Settings/Company/carparvaOutputLogin"
                            className={`nav-link ${isActive('/Settings/Company/carparvaOutputLogin')}`}
                            style={{ padding: "10px 10px", fontSize: "12px", whiteSpace: "nowrap" }}
                        >
                            Carparva Output Login
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link
                            to="/Settings/Company/philosophyVideo"
                            className={`nav-link ${isActive('/Settings/Company/philosophyVideo')}`}
                            style={{ padding: "10px 10px", fontSize: "12px", whiteSpace: "nowrap" }}
                        >
                            Philosophy Video
                        </Link>
                    </li>
                </ul>
            </PermissionWrapper>
        </div>
    )
}

export default CompanyHeader